































import { Component, Prop, Vue } from 'vue-property-decorator'

import { ListItem } from '@/layouts/components'

import { OptionGroup } from '@/models'

@Component({
  components: {
    ListItem
  }
})
export default class OptionGroupTile extends Vue {
  @Prop({ type: Object, required: true })
  readonly optionGroup!: OptionGroup

  @Prop({ type: Number, required: true })
  readonly itemGroupId!: number

  @Prop({ type: Boolean, required: true })
  readonly disabled!: boolean
}
